import "shared/extensions/date";

import { useGetLeaderboardFunctionRequest, useGetLeaderboardTemplateFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { LeaderboardDisplay } from "./LeaderboardDisplay";
import { NotFound } from "../../../../Views/NotFound";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { ViewStateWrapper } from "UIPalette/ViewStateWrapper/ViewStateWrapper";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NarrowContainer } from "shared/UI/LayoutComponents/LayoutComponents";
import { useEffect } from "react";
import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";

export const Leaderboard = () => {
  const { t } = useTranslation();
  const { code } = useParams();
  const { fetchTrackerDataFromDate } = useTrackerContext();

  const isCodeValid = code !== undefined && /^[XCJQ4D1TMB8G6R52A9E3Z7FV0HKNPSOW-]+$/.test(code);

  const { data, isLoading, error, mutate } = useGetLeaderboardFunctionRequest({ leaderboardCode: code }, { shouldFetch: isCodeValid });
  const templateResponse = useGetLeaderboardTemplateFunctionRequest({ id: data?.templateId! }, { shouldFetch: !!data?.templateId });

  useEffect(() => {
    if (data) {
      fetchTrackerDataFromDate(data.trackerType, Date.fromDateOnly(data.startDate) ?? new Date());
    }
  }, [data, fetchTrackerDataFromDate]);

  if (isLoading || !!error || !isCodeValid) {
    return (
      <>
        <PageTitle title={t("pageTitle.leaderboards.home")} />
        <PageHeader narrowView title={t("leaderboards.display.defaultPageHeader")} />
        <NarrowContainer>
          <ViewStateWrapper
            loading={isLoading}
            error={!!error}
            errorMessage={t("leaderboards.display.error")}
            onRetry={mutate}
            isFullScreenView={true}
          >
            <NotFound />
          </ViewStateWrapper>
        </NarrowContainer>
      </>
    );
  }

  const displayData = {
    id: data?.id!,
    templateId: data?.templateId!,
    name: data?.name!,
    trackerType: data?.trackerType!,
    code: data?.code!,
    startDate: data?.startDate!,
    endDate: data?.endDate!,
    participants: data?.participants!,
    description: templateResponse?.data?.description,
    isTemplateLoading: templateResponse?.isLoading,
  };

  return (
    <>
      <PageTitle title={t("pageTitle.leaderboards.code", { code: data?.name ?? "" })} />
      <LeaderboardDisplay {...displayData} />
    </>
  );
};
